// Import theme loader first to apply theme before anything else renders
import './theme-loader';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/responsive.css';
import './theme.css'; // Import theme styles
import App from './App';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

// Initialize user in Firestore on app startup if they're already logged in
const initializeUserInFirestore = async (user) => {
  if (!user) return;
  
  try {
    const { uid, email, displayName, photoURL } = user;
    const userRef = doc(db, "users", uid);
    const userDoc = await getDoc(userRef);
    
    // Only create the user document if it doesn't exist
    if (!userDoc.exists()) {
      console.log('Creating new user document for:', email);
      
      // Parse name from displayName or email
      const name = displayName || (email ? email.split('@')[0] : '');
      
      const userData = {
        uid,
        name,
        username: email,
        email,
        photoURL: photoURL || null,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        points: 10,
        isAdmin: false // Don't automatically make admins on app startup
      };
      
      // Set the user document
      await setDoc(userRef, userData);
      
      // Create initial points document
      const userPointsRef = doc(db, "users", uid, "stats", "points");
      await setDoc(userPointsRef, {
        total: 10,
        lastUpdated: serverTimestamp()
      });
      
      console.log('User document created successfully');
    } else {
      console.log('User document already exists');
    }
  } catch (error) {
    console.error('Error initializing user in Firestore:', error);
  }
};

// Set up auth state listener
onAuthStateChanged(auth, (user) => {
  if (user) {
    initializeUserInFirestore(user);
  }
});

// Unregister service worker and clear stale caches in development
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('Unregistered service worker:', registration);
    }
  });
  if (window.caches) {
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name);
        console.log('Purged cache:', name);
      }
    });
  }
}

// Try-catch to help identify rendering errors
try {
  console.log('Attempting to create root and render app...');
  // Create a root using the new React 18 API
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('App rendered successfully');
} catch (error) {
  console.error('Error rendering app:', error);
  // Add fallback rendering in case of errors
  document.getElementById('root').innerHTML = `
    <div style="padding: 20px; font-family: Arial, sans-serif;">
      <h1>Loading Error</h1>
      <p>There was a problem loading the application. Please try refreshing the page.</p>
      <pre>${error.toString()}</pre>
    </div>
  `;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
